import { useState, useEffect } from "react";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "../lib/api";
import { Button } from "./ui/button";
import { Textarea } from "./ui/textarea";
import { Sparkles, Loader2 } from "lucide-react";

export const PvpSummaryStep = ({ pvp, canEdit, onChange }) => {
  const [busy, setBusy] = useState(false);
  const [text, setText] = useState(pvp.management_summary || "");
  useEffect(() => {
    setText(pvp.management_summary || "");
  }, [pvp.management_summary]);

  const generate = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/pvps/${pvp.id}/summary`);
      onChange(data);
      toast.success("Management samenvatting geschreven");
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Samenvatting mislukt");
    } finally {
      setBusy(false);
    }
  };
  const save = async () => {
    try {
      onChange((await api.patch(`/pvps/${pvp.id}`, { management_summary: text })).data);
      toast.success("Opgeslagen");
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Opslaan mislukt");
    }
  };
  const skipped = Object.entries(pvp.section_status || {}).filter(([, v]) => v === "skipped").length;

  return (
    <div className="space-y-4" data-testid="pvp-summary-step">
      <p className="text-sm text-zinc-600">De AI schrijft de management samenvatting op basis van alle ingevulde onderdelen van dit PVP.{skipped > 0 && ` Let op: ${skipped} onderdeel/onderdelen zijn nog overgeslagen.`}</p>
      {canEdit && (
        <Button className="rounded-none bg-zinc-900 hover:bg-zinc-700" onClick={generate} disabled={busy} data-testid="pvp-generate-summary-button">
          {busy ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <Sparkles className="h-4 w-4 mr-2" />}
          {busy ? "AI schrijft…" : pvp.management_summary ? "Opnieuw laten schrijven" : "Laat AI de samenvatting schrijven"}
        </Button>
      )}
      {(pvp.management_summary || text) && (
        <>
          <Textarea value={text} onChange={(e) => setText(e.target.value)} disabled={!canEdit} rows={14} className="rounded-none border-zinc-400 font-serif text-[15px] leading-relaxed" data-testid="pvp-summary-text" />
          {canEdit && (
            <Button variant="outline" className="rounded-none" onClick={save} data-testid="pvp-save-summary-button">Wijzigingen opslaan</Button>
          )}
        </>
      )}
    </div>
  );
};
